export interface IWsArticulo {
    IdArticulo?: number;
    Detalle?: string;
    Descripcion?: string;
    Especificaciones?: any;
    Solucion?: string;
    Aplicacion?: string;
    Grupo?: string;
    imgRuta?: string;
    link?: string;
    orden?: number;
}

export class WsArticulo {
    IdArticulo?: number;
    Detalle?: string;
    Descripcion?: string;
    Especificaciones?: any;
    Familia?: string;
    Solucion?: string;
    Aplicacion?: string;
    Grupo?: string;
    Categoria?: string;
    Tipo?: string;
    imgRuta?: string;
    link?: string;
    orden?: number;

    // extras
    imgPath?: string;
    FlagEdicion?: boolean;

    constructor(data?: IWsArticulo) {
        if (!data) {
            data = { imgRuta: '' };
        }

        this.IdArticulo = data.IdArticulo;
        this.Detalle = data.Detalle;
        this.Descripcion = data.Descripcion;
        this.Especificaciones = data.Especificaciones;
        // this.Familia = data.Familia;
        this.Solucion = data.Solucion;
        this.Aplicacion = data.Aplicacion;
        this.Grupo = data.Grupo;
        // this.Categoria = data.Categoria;
        // this.Tipo = data.Tipo;
        this.imgRuta = data.imgRuta;
        if (this.imgRuta && this.imgRuta.indexOf('http') === -1) {
            this.imgPath = data.imgRuta;
        }
        this.link = data.link;
        this.orden = data.orden;
    }
}
